import * as sagaEffects from 'redux-saga/effects';
import axios from 'axios';

import { getIntl } from '@ackee/jerome/antd';
import message from 'antd/lib/message';

import config from 'config/index';
import * as loglevel from 'config/loglevel';

import types from '../actionTypes';

const { takeEvery } = sagaEffects;

function* handler() {
    const intl = yield getIntl();
    try {
        const baseUrl = `${config.cloudFunctions.base}${config.api.import}`;
        const url = config.app.importYaml ? `${baseUrl}/?importYaml=${config.app.importYaml}` : baseUrl;
        yield axios.get(url);
        message.success(intl.formatMessage({ id: 'success.imports.dispatch' }));
    } catch (e) {
        loglevel.error(e);
        message.error(intl.formatMessage({ id: 'errors.imports.dispatch' }));
    }
}

export default function* () {
    yield takeEvery(types.BEGIN_IMPORT, handler);
}
